import api from './client.js'

export const reportsAPI = {
  create:  (data) => api.post('/reports', data),
  mine:    () => api.get('/reports/mine'),
  public:  () => api.get('/reports/public'),
  detail:  (id) => api.get(`/reports/${id}`),
  list:    (params) => api.get('/reports', { params }),
  update:  (id, patch) => api.patch(`/reports/${id}`, patch),
  toggleUpvote: (id) => api.post(`/reports/${id}/upvote`),
  addComment:   (id, body) => api.post(`/reports/${id}/comments`, { body }),
  uploadFiles:  (id, files) => {
    const fd = new FormData()
    for (const f of files) fd.append('files', f)
    return api.post(`/reports/${id}/attachments`, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  deleteAttachment: (aid) => api.delete(`/reports/attachments/${aid}`),
}
